const delay = (timeout: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, timeout));

export const poll = (promiseFn: () => PromiseLike<void>, timeout: number): PromiseLike<void> =>
  promiseFn().then(() => delay(timeout).then(() => poll(promiseFn, timeout)));
